import { Role } from "@/model/role";

export class UserData {
  roles: Role[];

  constructor(roles: Role[]) {
    this.roles = roles;
  }
}
